import 'babel-polyfill'
// Import System requirements
import Vue from 'vue'
import VueRouter from 'vue-router'

import Notifications from 'vue-notification'
import {sync} from 'vuex-router-sync'
import routes from './routes'
import store from './store'

// import config from './config'
import EventBus from './store/eventBus'

// Import Helpers for filters
import {
  arrondissement,
  arrondissementName,
  allArrondissementName,
  allVillesName,
  profileName,
  secteurName,
  cantonnierName,
  maitriseName,
  genreType,
  materielType,
  collecteType,
  prettyFullDate,
  materielPicto,
  materielPictoV2,
  materielTypeV2,
  remonteeType,
  materielName,
  tourneeName,
  getMaterielFromDeclaration,
  genrePicto,
  evenementType,
  prettyDate,
  prettyTimeStamp,
  prettyDuration,
  returnCity,
  returnProfile
} from './filters'
import * as VueGoogleMaps from 'vue2-google-maps'
import ToggleButton from 'vue-js-toggle-button'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'

// Import Views - Top level
import AppView from './components/App.vue'

import moment from 'moment'
import _ from 'lodash'
import baseUrl from './config'
import realtime from './components/views/Realtime.vue'
import state from './store/state'

// Import Install and register helper items
Vue.filter('arrondissement', arrondissement)
Vue.filter('arrondissementName', arrondissementName)
Vue.filter('allArrondissementName', allArrondissementName)
Vue.filter('allVillesName', allVillesName)
Vue.filter('profileName', profileName)
Vue.filter('cantonnierName', cantonnierName)
Vue.filter('maitriseName', maitriseName)
Vue.filter('secteurName', secteurName)
Vue.filter('materielType', materielType)
Vue.filter('materielPicto', materielPicto)
Vue.filter('materielPictoV2', materielPictoV2)
Vue.filter('materielTypeV2', materielTypeV2)
Vue.filter('remonteeType', remonteeType)
Vue.filter('materielName', materielName)
Vue.filter('tourneeName', tourneeName)
Vue.filter('getMaterielFromDeclaration', getMaterielFromDeclaration)
Vue.filter('genreType', genreType)
Vue.filter('genrePicto', genrePicto)
Vue.filter('evenementType', evenementType)
Vue.filter('prettyDate', prettyDate)
Vue.filter('prettyTimeStamp', prettyTimeStamp)
Vue.filter('prettyDuration', prettyDuration)
Vue.filter('collecteType', collecteType)
Vue.filter('prettyFullDate', prettyFullDate)
Vue.filter('returnCity', returnCity)
Vue.filter('returnProfile', returnProfile)

// Notifications https://github.com/euvl/vue-notification
Vue.use(Notifications, {duration: 10000000})

// Router
Vue.use(VueRouter)

Vue.component('GmapCluster', GmapCluster)

// Toggle buttons
Vue.use(ToggleButton)
// Google map
Vue.use(VueGoogleMaps, {
  load: {
    // key: 'AIzaSyDYpVnlol0frsgnK_FqWEl0m211HX2V7Hk',
    key: 'AIzaSyClu1DjpsJ0csq-nuaUjz9XbnBDJcClSGk',
    libraries: 'places',  //// If you need to use place input
  },
})
//if (window) {
//   window.console.log = function () {}
//}
// Spacedog backend url https://cantonniers-bo-rec.suez.fr
if (location.origin.indexOf('cantonniers-bo.suez.fr') > -1 || location.origin.indexOf('marseillecantonniers-bo.suez.fr') > -1) { // eslint-disable-line no-undef
  // Prod
  //SpaceDog.initializeWithBaseUrl('https://marseillecantonniersws.suez.fr')
  //
} else if (location.origin.indexOf('cantonniers-bo-preprod.suez.fr') > -1 || location.origin.indexOf('marseillecantonniers-bo-preprod.suez.fr') > -1) {  // eslint-disable-line no-undef
  // Préprod
  // SpaceDog.initializeWithBaseUrl('https://marseillecantonnierswspreprod.suez.fr')
  //
} else if (location.origin.indexOf('cantonniers-bo-rec.suez.fr') > -1 || location.origin.indexOf('marseillecantonniers-bo-rec.suez.fr') > -1) {  // eslint-disable-line no-undef
  // Recette
  //SpaceDog.initializeWithBaseUrl('https://marseillecantonnierswsrec.suez.fr')
  //
} else {
  // SpaceDog.initializeWithBaseUrl('https://cantonnierswsdev.suez.fr')
  // SpaceDog.initializeWithBaseUrl('https://marseillecantonniersws.suez.fr')
  //SpaceDog.initializeWithBaseUrl('https://marseillecantonnierswsrec.suez.fr')
}

// Routing logic
var router = new VueRouter({
  routes: routes,
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || {x: 2, y: 0}
  },
})
// modules
const modules = [
  {
    path: 'realtime',
    module: 'TEMPS_REEL'
  },
  {
    path: 'map',
    module: 'PARCOURS'
  },
  {
    path: 'reporting',
    module: 'REPORTING'
  },
  {
    path: 'implantation_des_contenants',
    module: 'IMPLANTATION_DES_CONTENANTS'
  },
  {
    path: 'tournees',
    module: 'TOURNEES'
  },
  {
    path: 'materiels',
    module: 'MATERIELS'
  },
  {
    path: 'maitrises',
    module: 'MAITRISES'
  },
  {
    path: 'cantonniers',
    module: 'CANTONNIERS'
  },
  {
    path: 'secteurs',
    module: 'SECTEURS'
  },
  {
    path: 'demandes',
    module: 'DEMANDES'
  },
  {
    path: 'contenants',
    module: 'CONTENANTS'
  }
]
router.beforeEach((to, from, next) => {
  console.log('Hey')
  console.log('ROOOOOOOOLE => ', store.state.currentUser.role)
  let token = localStorage.getItem('TOKEN')
  if (to && to.name && to.path === '/rgpd' && !token) {
      next()
  } else if (to && to.name && to.name !== 'ResetPassword' && to.name !== 'Login' && !store.state.login.loggedIn) {
    console.log('Hey 1')
    console.log('to.name => ', to.name)
    window.console.log(`Not authenticated ${to.name !== 'Login'} && ${store.state.login.loggedIn} `)
    next({
      path: '/login',
      query: {redirect: to.fullPath},
    })
  } else if (to && to.path && to.name && state.currentVille.moduleBackoffice.length > 0 && to.name !== 'Login' && !to.name.includes('Administration') && !to.name.includes('Statistiques') && !to.path.includes('rgpd') && store.state.currentUser.role !== 'COLLECTIVITY_USER') {
    console.log('Hey 2')
    var isActif
    var path = to.path.replace('/', '')
    if (path === '401') {
      next()
    } else {
      let module = modules.find(m => m.path === path)
      isActif = state.currentVille.moduleBackoffice.find(m => m.parametrageBOMenu === module.module).actif
      if (!isActif) {
        next({
          path: '/401',
        })
      } else {
        next()
      }
    }
  } else if (to && to.name && store.state.currentUser.role === 'COLLECTIVITY_USER') {
    console.log('hello colect => ', to.name)
    if (to.name.includes('Administration') || to.name.includes('Statistiques') || to.path.includes('materiels') || to.path.includes('maitrises') || to.path.includes('cantonniers') || to.path.includes('secteurs') || to.path.includes('demandes') || to.path.includes('tournees')) {
      next({
        path: '/401',
      })
    } else {
      next()
    }

  } else {
    console.log("to.name " , to.name)
    console.log("to.path " , to.path)
    if (to && to.name && to.path === '/rgpd') {
      let token = localStorage.getItem('TOKEN')
      console.log(token)
      next()
    }
    console.log('Hey 3')
    if (to && to.name && to.name.includes('Administration') && (store.state.currentUser.role === 'USER')) {
      next({
        path: '/401',
      })
    } else {
      next()
    }
  }
})

router.afterEach((to, from) => {
  EventBus.$emit('closeMenu')
})

sync(store, router)

// init moment locale
moment.locale('fr')

// Start out app!
// eslint-disable-next-line no-new
new Vue({
  el: '#root',
  router: router,
  store: store,
  render: h => h(AppView),
})




// WEBPACK FOOTER //
// ./src/main.js